import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IKioskConfigGridData } from '../model/kioskConfig_grid_data';
import { DataBindingDirective, GridDataResult } from '@progress/kendo-angular-grid';
import { Observable, Subscription } from 'rxjs';
import { KioskConfigurationService } from '../kiosk-configuration.service';
import { KioskGridParams } from '../model/kiosk_grid_params';
import { PageInfo } from '../../user/shared/models/pageInfoModel';
import { SortInfo } from '../../user/shared/models/sortInfoModel';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { SortDescriptor } from '@progress/kendo-data-query';

import { AppState } from 'src/app/shared/models/store models/app-state.interface';
import { Store } from '@ngrx/store';
import { getUrlCodeForCurrentTenant, GetUserPermissionList } from 'src/app/state';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
declare const window: any;
@Component({
  selector: 'app-kiosk-configuration-grid',
  templateUrl: './kiosk-configuration-grid.component.html',
  styleUrls: ['./kiosk-configuration-grid.component.scss']
})

export class KioskConfigurationGridComponent implements OnInit , OnDestroy{
  columns: any[] = [{ field: 'locationCode' }, { field: 'locationName' }];
  bindingType: string = 'array';
  searchText: string = '';
  view: Observable<GridDataResult> = new Observable<GridDataResult>();
  kioskGridSource: IKioskConfigGridData[] = [];
  kioskGridData: IKioskConfigGridData[] = [];
  pageSize: number = 25;
  skip: number = 0;
  showPopUp: boolean = false;
  copySettingsForm: FormGroup;
  kioskCreatedList: IKioskConfigGridData[] = [];
  kioskNotCreatedList: IKioskConfigGridData[] = [];
  deleteMessage: string = '';
  locationIdToBeDeleted: number = 0;

  public dropdownSettings: IDropdownSettings;
  private kioskUrl: string = '';
  private urlCode: string = '';
  private appConfig!: AppConfigurations;

  private subscriptions = new Subscription();
  public userPermissionList: number[] = [];

  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective = {} as DataBindingDirective;

  public sort: SortDescriptor[] = [{
    field: 'locationCode',
    dir: 'asc'
  }];

  private subs = new Subscription();
  constructor(
      private kioskService: KioskConfigurationService, 
      private router: Router, 
      private formBuilder: FormBuilder,
      private toastService: ToastService, 
      private store:Store<AppState>,
      private appInitService: AppInitService,
      private translationLoaderFacade: TranslationLoaderFacade,
      private translateService: TranslateService) {

        this.dropdownSettings = {
          singleSelection: false,
          idField: 'locationId',
          textField: 'locationName',
          enableCheckAll: true,
          selectAllText: this.translateService.instant('_General_Select_All_Text_'),
          unSelectAllText: this.translateService.instant('_General_Unselect_All_Ts_Text_'),
          itemsShowLimit: 3
        };

        this.copySettingsForm = this.formBuilder.group({
          selectAll: false,
          copyFrom: ['', Validators.required],
          copyToValues: [null, Validators.required]
        });
    }

  ngOnInit() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (!allUserPermissions) {
        throw Error('allUserPermissions is undefined!');
      }
      this.userPermissionList = allUserPermissions;
    });
    const configsub = this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => this.onReceiveappConfig(config)
    })

    this.subs.add(configsub);

    this.getKioskConfigurationGridData();
    
    let urlCodeSubs = this.store.select(getUrlCodeForCurrentTenant).subscribe(urlcode => this.urlCode = urlcode);
    this.subscriptions.add(urlCodeSubs);
  }
  private onReceiveappConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig
    this.kioskUrl = this.appConfig.kioskUrl;
  }

  private getGridParams(): KioskGridParams {
    const kioskGridParams = new KioskGridParams();
    kioskGridParams.pageInfo = new PageInfo();
    kioskGridParams.pageInfo.Page = 1;
    kioskGridParams.pageInfo.PageSize = 10;
    kioskGridParams.sortInfo = new SortInfo();
    kioskGridParams.sortInfo.SortColumn = 'locationCode';
    kioskGridParams.sortInfo.sortDirection = 1;
    kioskGridParams.searchText = '';
    return kioskGridParams;

  }

  getKioskConfigurationGridData() {
    const gridParams = this.getGridParams();
    this.kioskService.getKioskConfigurations(gridParams).subscribe({
      next: (data: IKioskConfigGridData[]) => {
        this.kioskGridSource = data;
        this.kioskGridData = data;

        // no need to sort the two lists below again, unless it's to be sorted by a property other than the location code
        // The location list from the API is by default sorted by the location code, we are only splitting it to two arrays
        // based on whether kiosks are created or not, so the sort order persists
        // *** rework the sort if the default sort order changes
        this.kioskCreatedList = this.kioskGridData.filter(k => k.kioskCreated === true);
        this.kioskNotCreatedList = this.kioskGridData;
      },
      error: (err) => {this.handleError(err, '_Kiosks_File_Change_Ts_Text_');}
    });
  }

  public editKioskConfiguration(dataItem: IKioskConfigGridData) {
    const locationCode = dataItem.locationCode;
    const encodeLocationCodes = encodeURIComponent(locationCode);
    this.router.navigate([`admin/kiosk/kiosk-settings/${encodeLocationCodes}`], { queryParams: { mode: "edit", id: dataItem.locationId, name: dataItem.locationName } });
  }

  public addKioskConfiguration(dataItem: IKioskConfigGridData) {
    const locationCode = dataItem.locationCode;
    const encodeLocationCodes = encodeURIComponent(locationCode);

    this.router.navigate([`admin/kiosk/kiosk-settings/${encodeLocationCodes}`], { queryParams: { mode: "add", id: dataItem.locationId, name: dataItem.locationName } });
  }

  public deleteKioskConfiguration() {
    this.kioskService.deleteKioskConfiguration(this.locationIdToBeDeleted).subscribe({
      next: () => {
        this.deleteCompleted();
        this.getKioskConfigurationGridData();
      },
      error : (err) => {this.handleError(err, '_Kiosks_Deletion_Failed_Ts_Text_'); }
    });
  }

  private deleteCompleted() {
    this.showSuccessToast('_Kiosks_Deleted_Successfully_Ts_Text_');
    this.locationIdToBeDeleted = 0;
  }


  public showHideCopyPopup() {
    this.showPopUp = !this.showPopUp;
  }

  copyKioskConfiguration() {
    const copySettings = { ...this.copySettingsForm.value };
    const copyToIdArray = copySettings.copyToValues.map((c: IKioskConfigGridData) => c.locationId);
    this.kioskService.copyKioskConfigurations(copySettings.copyFrom, copyToIdArray).subscribe({
      next: () => {
        this.showSuccessToast('_General_Changes_Saved_Successfully_Ts_Text_');
        this.closeCopySettingPopup();
        this.getKioskConfigurationGridData();
      },
      error: (err) => {
        this.handleError(err, '_General_Saving_Failed_Ts_Text_');
      }
    });
  }

  closeCopySettingPopup() {
    this.copySettingsForm.patchValue({
      copyFrom: '',
      copyToValues: [],
      selectAll: false
    });
    this.showPopUp = false;
  }

  selectAll() {
    const isSelected = this.copySettingsForm.get('selectAll')!.value;
    if (isSelected) {
      const allCopyToValues = this.kioskNotCreatedList.map(c => c.locationId);
      this.copySettingsForm.patchValue({
        copyToValues: allCopyToValues
      });
    } else {
      this.copySettingsForm.patchValue({
        copyToValues: []
      });
    }
  }

  public openDeletePopup(popUp: any, dataItem: any) {
    this.translateService.get('_Kiosks_Delete_Kiosk_Message_Ts_Text_', {val1: dataItem.locationName}).subscribe(translatedString => {
      this.deleteMessage = translatedString;
    });
    this.locationIdToBeDeleted = dataItem.locationId;
    this.openDeleteKioskConfigPopUp(popUp);
  }

  public closeDeleteKioskConfigPopUp(popUp: any) {
    this.locationIdToBeDeleted = 0;
    popUp.dialogOpened = false;
  }

  openDeleteKioskConfigPopUp(popUp: any) {
    popUp.dialogOpened = true;

  }

  search(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      // initialize the kioskGridSource again,
      // otherwise, for an empty-result search, the previous kioskGridSource collection is retained and displayed
      this.kioskGridSource = [];
      const filteredDataSource = this.kioskGridData.filter(x => x.locationName.toLowerCase().indexOf(target.value.toLowerCase()) >= 0
        || x.locationCode.toLowerCase().indexOf(target.value.toLowerCase()) >= 0);
      this.kioskGridSource = filteredDataSource;
      this.dataBinding.skip = 0;
    } else {
      this.kioskGridSource = this.kioskGridData;
    }
  }

  searchOnClick(searchText: string) {
    if (searchText) {
      // initialize the kioskGridSource again,
      // otherwise, for an empty-result search, the previous kioskGridSource collection is retained and displayed
      this.kioskGridSource = [];
      const filteredDataSource = this.kioskGridData.filter(x => x.locationName.toLowerCase().indexOf(searchText.toLowerCase()) >= 0
        || x.locationCode.toLowerCase().indexOf(searchText.toLowerCase()) >= 0);
      this.kioskGridSource = filteredDataSource;
      this.dataBinding.skip = 0;
    } else {
      this.kioskGridSource = this.kioskGridData;
    }
  }

  /**
  * Triggers when user click the clear search button.
  *  
  */
   public onClearSearchTextClicked() {
    this.searchText = '';    
    this.kioskGridSource = this.kioskGridData;
  }

  handleError(err: any, errorMessage: string) {
    console.log(err);
    this.toastService.showError(errorMessage);
  }

  showSuccessToast(successMessage: string) {
   this.toastService.showSuccess(successMessage);
  }

  launchKiosk(locationCode: string) {
    const encodeLocationCode = encodeURIComponent(locationCode);
    const url = `${this.kioskUrl}?locationCode=${encodeLocationCode}&urlCode=${this.urlCode}`;
    window.open(url, '_blank');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
